<template>
  <div>
    <van-nav-bar title="个人中心" left-text="" right-text="" @click-right=""/>
    <van-cell title="账号" icon="idcard" :value="account"/>
    <van-cell title="昵称" icon="manager-o" :value="nickname"/>
<!--    <van-cell title="修改密码" is-link @click="toUpdatePwd" />-->
<!--    <div style="margin: 16px;">-->
<!--      <van-button round block type="info" native-type="submit" @click="loginOut">退出登录</van-button>-->
<!--    </div>-->
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" @click="jumpPage">首页</van-tabbar-item>
      <van-tabbar-item icon="friends-o">个人中心</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>

import Vue from "vue";
import {isWechat} from "../../utils/util";

export default {
  name: "CustomerUser",
  data() {
    return {
      active: 1,
      account: '',
      nickname: ''
    };
  },
  mounted() {
    if(!isWechat()){
      this.$router.push({
        path: "/attenceflow/Error",
        query: {
        }
      });
    }
    this.$fetch("/attence-api/blade-user/info", {}).then(
      res => {
        const data = res.data;
        this.nickname = data.name;
        this.account = data.account;
        console.log("返回的数据：" + JSON.stringify(data));
      },
      error => {

      }
    );
  },
  methods: {
    jumpPage: function () {
      this.$router.push({
        path: "/attenceflow/AttenceHome",
        query: {}
      });
    },
    loginOut: function () {
      localStorage.removeItem('token');
      this.$router.push({
        path: "/",
        query: {}
      });
    },
    toUpdatePwd: function () {
      this.$router.push({
        path: "/attenceflow/PasswordUpdate",
        query: {}
      });
    },
  }
}
</script>

<style scoped>
.van-nav-bar {
  background-color: #2196f3;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

/deep/ .van-nav-bar__text {
  color: #fff;
}

.login-form-top {
  margin-top: 0px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/attenceflow/UserInfo.vue